import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { makeStyles } from '@material-ui/core';

import 'moment/locale/es';
import moment from 'moment';

import Datatable from '../../../shared/ui/components/Datatable';
import getPaymentList from 'src/payment/use-cases/getPaymentList';

import CustomerAccountSummaryStatus from 'src/customer/ui/components/CustomerAccountSummaryStatus';

const useStyles = makeStyles((theme) => ({
  customerAccountStatus: {
    paddingBottom: theme.spacing(3)
  }
}));

const PaymentDatatable = ({
  customerId,
  handleAdd,
  handleDownload,
  handleClickExportExcel,
  showAddButton
}) => {
  const navigate = useNavigate();

  const classes = useStyles();

  const [list, setList] = useState({
    rows: [],
    count: 0
  });
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [orderBy, setOrderBy] = useState({
    columnName: null,
    orderBy: null
  });

  const user = JSON.parse(localStorage.user);

  const fetchList = async () => {
    const companyHeadquarterId = localStorage.selectedUserHeadquarter;

    const response = await getPaymentList({
      companyHeadquarterId,
      customerId,
      search,
      orderBy: orderBy.columnName
        ? `${orderBy.columnName} ${orderBy.orderBy}`
        : '',
      page,
      limit
    });

    response.rows = response.rows.map((x) => {
      let monthNameTermList = {
        monthNameTermList: Array.from(
          new Set(
            x.CustomerInvoice.customerTermList.map((y) =>
              moment(y.date)
                .format('MMMM')
                .toUpperCase()
            )
          )
        ).join(' ')
      };
      return {
        ...x,
        ...monthNameTermList
      };
    });

    setList(response);
  };

  useEffect(() => {
    fetchList();
  }, [page, limit, search, orderBy]);

  const handleSearch = (searchValue) => {
    setPage(0);
    setSearch(searchValue.target.value);
  };

  const handleChangePage = (pageIndex) => {
    setPage(pageIndex);
  };

  const handleChangeLimit = (limitIndex) => {
    setLimit(limitIndex);
  };

  const handleOrderBy = (column) => {
    setOrderBy(column);
  };

  const handleClickAdd = (event) => {
    handleAdd();
  };

  const handleClickDownload = (event, id, row) => {
    handleDownload(id, row);
  };

  const handleClickEdit = (event, id) => {
    navigate(`/app/payments/${id}`, {
      replace: false
    });
  };

  const columnNameList = [
    'datetime',
    'PaymentStatus.code',
    'validationStatus',
    'number',
    'monthNameTermList|datetime',
    user.scopes.includes('admin:payments')
      ? 'HeadquarterCustomer.businessName,LINK:/app/customers/:headquarterCustomerId'
      : 'HeadquarterCustomer.businessName',
    '${BillingCustomerContact.firstname}${BillingCustomerContact.surnames}|BillingCustomerContact.firstname',
    'document',
    'PaymentType.code',
    'invoiceStampingNumber',
    'invoiceNumber',
    'amount',
    'invoiceAmount',
    'rest',
    '${Employee.firstname}${Employee.surnames}',
    '${User.firstname}${User.surnames}',
    'reference',
    'comments',
    'internalComments',
    'promiseDate'
  ];

  if (localStorage.selectedUserHeadquarter === 'all') {
    columnNameList.unshift('CompanyHeadquarter.name');
  }

  return (
    <>
      {customerId && (
        <div className={classes.customerAccountStatus}>
          <b>Estado de cuenta</b>
          <CustomerAccountSummaryStatus
            customerId={customerId}
            customerPaymentReceiptList={list}
          />
        </div>
      )}
      <Datatable
        domainName="PAYMENT"
        dataList={list.rows}
        count={list.count}
        addButtonText={showAddButton ? 'Registrar nuevo pago' : ''}
        addButtonRoute={showAddButton ? '/app/payments/new' : false}
        title="Listado de pagos"
        exportExcelButton={user?.scopes.includes('admin:payments')}
        onSearch={handleSearch}
        onChangePageValue={handleChangePage}
        onChangePageLimit={handleChangeLimit}
        handleOrderBy={handleOrderBy}
        handleClickAdd={handleClickAdd}
        handleClickDownload={handleClickDownload}
        handleClickExportExcel={handleClickExportExcel}
        handleClickEdit={handleClickEdit}
        columnNameList={columnNameList}
      />
    </>
  );
};

export default PaymentDatatable;
